export default __webpack_public_path__ + "static/media/lab-test-portal.7bf95fa8.png";